import React from "react";
import { Loading } from "carbon-components-react";
import "./loader.scss";

export const Loader = () => {
  return (
    <div className="page-loader">
      <Loading small={true} withOverlay={false} />
    </div>
  );
};
